import { render, staticRenderFns } from "./configuration-automation-personnel-algorithms-definition-grid.vue?vue&type=template&id=1ad6c895&scoped=true&"
import script from "./configuration-automation-personnel-algorithms-definition-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-personnel-algorithms-definition-grid.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-personnel-algorithms-definition-grid.scss?vue&type=style&index=0&id=1ad6c895&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad6c895",
  null
  
)

export default component.exports